var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.75C1 3.57436 3.57436 1 6.75 1H16.75C19.9256 1 22.5 3.57436 22.5 6.75V16.75C22.5 19.9256 19.9256 22.5 16.75 22.5H6.75C3.57436 22.5 1 19.9256 1 16.75V6.75ZM6.75 2.5C4.40279 2.5 2.5 4.40279 2.5 6.75V16.75C2.5 19.0972 4.40279 21 6.75 21H16.75C19.0972 21 21 19.0972 21 16.75V6.75C21 4.40279 19.0972 2.5 16.75 2.5H6.75Z",
    fill: "#42C67E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2803 15.2803C10.9874 15.5732 10.5126 15.5732 10.2197 15.2803L7.21967 12.2803C6.92678 11.9874 6.92678 11.5126 7.21967 11.2197C7.51256 10.9268 7.98744 10.9268 8.28033 11.2197L10.75 13.6893L16.2197 8.21967C16.5126 7.92678 16.9874 7.92678 17.2803 8.21967C17.5732 8.51256 17.5732 8.98744 17.2803 9.28033L11.2803 15.2803Z",
    fill: "#42C67E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck24X24);
export default __webpack_public_path__ + "static/media/CHECK_24X24.9c7b7d791663f8d46a92b093e2079755.svg";
export { ForwardRef as ReactComponent };